export const personalLoans = [
  { value: '', text: "What's the money for?" },
  { value: 'credit_card', text: 'Credit card refinancing' },
  { value: 'debt_consolidation', text: 'Debt consolidation' },
  { value: 'home_improvement', text: 'Home improvement' },
  { value: 'major_purchase', text: 'Major purchase' },
  { value: 'house', text: 'Home buying' },
  { value: 'car', text: 'Car financing', url: '/apply/auto/identity' },
  { value: 'renewable_energy', text: 'Green loan' },
  { value: 'small_business', text: 'Business' },
  { value: 'vacation', text: 'Vacation' },
  { value: 'moving', text: 'Moving and relocation' },
  {
    value: 'medical',
    text: 'Medical expenses',
    url: '/patientsolutions/patients',
    customTitle: 'Medical loans',
    customMaxAmount: 65000,
  },
  { value: 'other', text: 'Other' },
];

const note = "Won't impact your credit score";
const helpNote = `Checking your rate generates a soft credit inquiry, which is visible only to you. A hard credit inquiry that may affect your credit score only appears when your loan is issued.`;

export const tooltip = {
  note,
  helpNote,
};

export const title = 'How much do you need ?';

export const url = '/apply/personal/identity/loan-type';

const path = 'https://lendingclub.com//apply/myinstantoffer';
const label = 'Respond to Mail Offer';
export const mailOffer = {
  path,
  label,
};
export const inputPlaceholder = 'Enter $1,000 to $40,000';
export const offerCodePlaceholder = 'Enter your 12-digit code';
export const ciabCodePlaceholder = 'Enter your 10-digit code';
export const ctaLabel = 'Check Your Rate';
export const ctaVariant = 'Solid';
export const ctaColor = 'True Blue';
export const queryParams =
  'utm_source=website&utm_campaign=ciab&utm_content=ciab_fundingcode';
export const popupHead = 'Where to find my code?';
export const popupBody =
  'In the printed letter we sent you, look for a 12-digit alphanumeric code with hyphens. You will use this code to start your Online Application.';
export const popupFooter =
  'No? Speak with a Dedicated Credit Specialist 1-855-363-4151 (Mon-Fri 5 am-5 pm PST)';
export const prequalType = 'Offer code';

export const ciabErrors = {
  ERROR_INVALID_CODE: 'Oops! A valid code is required. Please try again.',
  ERROR_EXCEPTION:
    'Oops! The code you entered does not match our records. Please try again.',
  ERROR_400:
    'Oops! The code you entered does not match our records. Please try again.',
  ERROR_404:
    'Oops! The code you entered does not match our records. Please try again.',
  ERROR_410: 'The code you entered has expired.',
  ERROR_500:
    'Oops! The code you entered does not match our records. Please try again.',
  ERROR_503:
    'Oops! The code you entered does not match our records. Please try again.',
};

export const validationPopUpBodyForExpired =
  'In the printed letter we sent you, look for a 10-digit alphanumeric code with hyphens. You will use this code to start your Online Application.';
export const validationPopUpBodyForNotFound = '';
export const validationPopUpButton = {
  link: '/test',
  label: 'Start a New Application',
};
export const validationPopUpFooter = 'Try a Different RSVP Code';
